{
  "title": "Detect Evil and Good",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level divination",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "For the duration, you know if there is an aberration, celestial, elemental, fey, fiend, or undead within 30 feet of you, as well as where the creature is located. Similarly, you know if there is a place or object within 30 feet of you that has been magically consecrated or desecrated.",
    "The spell can penetrate most barriers, but it is blocked by 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt."
  ],
  "spellLists": ["cleric", "paladin"]
}
